'use client';

import { useTranslation as t } from '../../../hooks/useTranslation';
// import { TokenProps, hasToken } from '../../../utils/servicesUtil';
// import jwt_decode from 'jwt-decode';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { getUser } from '../../../utils/auth';
import { EpStepContent } from '../components';
import { EpFormInput } from '../components/EpFormInput';

export default function NotifierNameInput({
  translations,
}: {
  translations: string[];
}) {
  // @TODO: substituir consistência de token quando houver login real do sistema
  const { setValue, unregister, formState: { errors } } = useFormContext();
  const pathname = usePathname();
  const isPublicPath = pathname.includes('Public');

  const user = getUser();
  const isLogged = user && !isPublicPath;
  const anonymous = useWatch({ name: 'anonymous' });

  useEffect(() => {
    unregister('notifierName');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anonymous, isPublicPath]);

  if (anonymous) return null;
  if (isLogged) setValue('notifierName', user?.fullname);

  return (
    <>
      <EpStepContent.Label label={t(translations, 'Full Name') + ' *'}>
        <EpFormInput
          inputName="notifierName"
          inputType="text"
          inputPlaceholder={t(translations, 'Name')}
          inputRequired
          inputIsDisabled={isLogged}
          translations={translations}
          inputWithError={!!errors[`notifierName`]}
          inputIsFullWidth
        />
      </EpStepContent.Label>
      {/* <EpErrorMessage inputName="notifierName" /> */}
    </>
  );
}
